import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.63726 1.11864C3.1374 0.817256 2.5 1.17723 2.5 1.76093V10.2403C2.5 10.824 3.13739 11.184 3.63726 10.8826L10.6689 6.64289C11.1526 6.35128 11.1526 5.64993 10.6689 5.35832L3.63726 1.11864Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }